import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/rapportages')({
    component: RapportagesPage,
});

function RapportagesPage() {
    return <h1 className="p-6 text-lg font-medium text-[#202020]">Rapportages</h1>;
}
